import { Routes, Route } from "react-router-dom";
import MainContainer from "./layout/MainContainer";
import Pages from "./pages";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Dashboard />} />
        <Route path="/analytics" element={<Pages.Analytics />} />
        <Route path="/manage-users" element={<Pages.ManageUser />} />
        <Route
          path="/manage-users/detail"
          element={<Pages.ManageUserDetail />}
        />
        <Route path="/manage-users/edit" element={<Pages.Edituser />} />
        <Route path="/manage-users/add" element={<Pages.Edituser />} />
        <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
        <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
        <Route
          path="/manage-subadmin/detail"
          element={<Pages.SubadminDetail />}
        />
        <Route
          path="/manage-subadmin/roles"
          element={<Pages.ManageSubadminRoles />}
        />
        <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
        <Route
          path="/manage-subadmin/roles/detail"
          element={<Pages.RoleDetail />}
        />

        <Route
          path="/manage-notifications"
          element={<Pages.ManageNotifications />}
        />
        <Route
          path="/manage-notifications/add"
          element={<Pages.AddNotification />}
        />
        <Route
          path="/manage-notifications/detail"
          element={<Pages.NotificationDetail />}
        />
        <Route
          path="/recieved-notifications"
          element={<Pages.RecievedNotifications />}
        />
        <Route
          path="/manage-system-settings"
          element={<Pages.ManageSystemSettings />}
        />
        <Route
          path="/manage-system-settings/add-email-template"
          element={<Pages.AddEmailTemplate />}
        />
        <Route path="/manage-cms" element={<Pages.ManageCms />} />
        <Route path="/manage-profile" element={<Pages.ManageProfile />} />
        <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
        <Route
          path="/manage-profile/change-password"
          element={<Pages.ChangePassword />}
        />

        <Route path="/manage-categories" element={<Pages.ManageCategories />} />
        <Route path="/manage-categories/add" element={<Pages.AddCategory />} />
        <Route path="/manage-categories/edit" element={<Pages.AddCategory />} />
        <Route
          path="/manage-categories/view"
          element={<Pages.ViewPromotion />}
        />
        <Route path="/manage-products" element={<Pages.ManageProducts />} />
        <Route path="/manage-products/add" element={<Pages.AddProduct />} />
        <Route
          path="/manage-products/detail"
          element={<Pages.ProductDetail />}
        />
        <Route path="/manage-qr-code" element={<Pages.ManageQrCode />} />
        <Route
          path="/manage-boost-plans"
          element={<Pages.ManageBoostPlans />}
        />
        <Route
          path="/manage-boost-plans/add"
          element={<Pages.AddBoostPlans />}
        />
        <Route
          path="/manage-boost-plans/detail"
          element={<Pages.BoostPlanDetail />}
        />
        <Route path="/manage-payments" element={<Pages.ManagePayments />} />
        <Route path="/manage-payments/view" element={<Pages.ViewPayments />} />
        <Route
          path="/manage-activity-logs"
          element={<Pages.ManageActivityLogs />}
        />
        <Route path="/customer-supports" element={<Pages.Support />} />
        <Route path="/customer-supports/view" element={<Pages.SupportView />} />
        <Route path="/customer-supports/chat" element={<Pages.SupportChat />} />
        <Route path="/manage-reviews" element={<Pages.ManageReviews />} />
      </Route>
    </Routes>
  );
};

export default Routing;
